import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components/macro';

export const Container = styled(Paper)`
    max-width: 1000px;
    margin: 0 auto;
    padding: 16px
`;

export const Logo = styled.img`
    max-height: 95px;
    max-width: 100%;
    margin: 0 auto 24px;
    display: block;
`;

export const Subtitle = styled(Typography)`
    margin-top: 16px;
    text-align: center;
    font-size: 15pt;
    margin-bottom: 8px;
`;

export const AddProductContainer = styled.div`
    text-align: right;

    @media (max-width: 900px) {
        text-align: center;
    }
`;

export const AddProductButton = styled(Button)`
    margin-top: 12px;
`;

export const DisclaimerText = styled(Typography)`
    margin-top: 12px;
`;

export const LanguageSelectorWrapper = styled.div`
    margin-top: 18px;
`;